import {
  GET_COLLECTION,
  GET_COLLECTION_SUCCESS,
  GET_COLLECTION_ERROR,

  CREATE_COLLECTION_NEW_RECORD,
  CREATE_COLLECTION_NEW_RECORD_SUCCESS,
  CREATE_COLLECTION_NEW_RECORD_ERROR, 
} from "../actions";

export const getCollection = (collectionId, activityInfo) => ({
    type: GET_COLLECTION,
    payload: { collectionId, activityInfo},
  });

export const getCollectionSuccess = (collection) => ({
  type: GET_COLLECTION_SUCCESS,
  payload: collection,
});

export const getCollectionError = (message) => ({
  type: GET_COLLECTION_ERROR,
  payload: { message },
});

export const createCollectionNewRecord = (newRecord, history) => ({
    type: CREATE_COLLECTION_NEW_RECORD,
    payload: { newRecord, history},
  });

export const createCollectionNewRecordSuccess = (recordCreated) => ({
  type: CREATE_COLLECTION_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createCollectionNewRecordError = (message) => ({
  type: CREATE_COLLECTION_NEW_RECORD_ERROR,
  payload: { message },
});